import { Button, CardBody, CardFooter, Popover, Radio, RadioGroup } from '@panwds/react-ui';
import React, { useEffect, useState } from 'react';
import { useFilters } from '../../hooks/index.js';
import { PillValue } from '../Pill/PillValue.js';
import { useIntl } from 'react-intl';
export function RangeFilterOptions({ items, label, required = false, disabled = false, radioSelected, updateRadioSelected, onClearClick, name, rangeValues, isFullWidth, onClose }) {
    const intl = useIntl();
    const { setFilters } = useFilters();
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        // set initial filters on load
        if (loaded === false) {
            setFilters({
                [name]: rangeValues
            });
        }
        setLoaded(true);
    }, [rangeValues]);
    const onRadioChange = (e) => {
        updateRadioSelected(e.target.value);
    };
    const onApplyClick = () => {
        setFilters({
            [name]: rangeValues
        });
    };
    const button = (React.createElement(PillValue, { labelKey: label, labelValue: label, required: required, onClose: onClose, disabled: disabled, isFullWidth: isFullWidth }));
    const getRadioGroupItems = () => {
        return items?.map((item) => {
            let radio = (React.createElement(Radio, { value: item.value, checked: false }, item.children));
            let generatedOption = null;
            if (radioSelected === item.value) {
                radio = (React.createElement(Radio, { value: item.value, checked: true }, item.children));
                generatedOption = (React.createElement("div", { className: "tw-ml-8", key: item.value }, item.rangeOptions));
            }
            return (React.createElement("div", { key: item.value, className: "tw-flex tw-h-6" },
                radio,
                generatedOption));
        });
    };
    const radioOptions = () => {
        return (React.createElement("div", { className: "tw-space-y-4 tw-min-w-80" },
            React.createElement(RadioGroup, { name: "rangeFilter", value: radioSelected, onChange: onRadioChange }, getRadioGroupItems())));
    };
    return (React.createElement("div", { className: "tw-rounded", "data-testid": name, "data-metrics": name },
        React.createElement(Popover, { label: label, showLabel: false, button: button },
            React.createElement(CardBody, { addClassName: " tw-flex tw-flex-col tw-space-y-2" }, radioOptions()),
            React.createElement(CardFooter, { noDivider: false },
                React.createElement("div", { className: "tw-flex tw-space-x-2" },
                    React.createElement(Button, { type: "button", appearance: "tertiary", onClick: onClearClick }, intl.formatMessage({ defaultMessage: 'Clear', id: 'nqRX/c', description: 'Clear the filter' })),
                    React.createElement(Button, { appearance: "primary", onClick: onApplyClick }, intl.formatMessage({ defaultMessage: 'Apply', id: 'pH5qqz', description: 'Apply the filter' })))))));
}
//# sourceMappingURL=RangeFilterOptions.js.map